module.exports = __webpack_public_path__ + "img/Payment_Cash.0e571015.svg";